import { http } from 'src/core/services/http';
import { StopMapDetails } from '../interfaces/StopMapDetails';

export const loadStopMapDetails = (vendorId: number, routeId: number, routeLocationId: number) =>
  http
    .get<StopMapDetails>(`${vendorId}/routes/${routeId}/routeDetail/stopMapDetails`, { params: { routeLocationId } })
    .then(response => response.data);
